import { render, staticRenderFns } from "./QuanLyTrungTamHoTro.vue?vue&type=template&id=08e93c32"
import script from "./QuanLyTrungTamHoTro.vue?vue&type=script&lang=js"
export * from "./QuanLyTrungTamHoTro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports